/*
* @prop --component-slider-color-pagination-inactive: color of inactive slider pagination.
* @prop --component-slider-color-pagination-inactive-background: background color of inactive slider pagination
* @prop --component-slider-color-pagination-active-background: background color of active slider pagination
* @prop --component-slider-color-pagination-active: color of active slider pagination
* @prop --component-slider-color-arrows: color of slider arrows
*/

@import '~swiper/modules/navigation/navigation';
@import '~swiper/modules/pagination/pagination';
@import '~swiper/modules/effect-fade/effect-fade';
@import '~swiper/swiper';

.ui-slider {
  display: block;
  position: relative;
  z-index: 0; // Creating an own z-index-scope prevents children of this element overlapping other elements

  &__controls {
    align-items: center;
    display: flex;
    justify-content: center;
    margin-top: 22px;

    .swiper-pagination,
    .swiper-button-next,
    .swiper-button-prev {
      position: static;
    }

    .swiper-pagination-fraction,
    .swiper-pagination-custom,
    .swiper-horizontal > .swiper-pagination-bullets,
    .swiper-pagination-bullets.swiper-pagination-horizontal {
      width: auto;
    }

    .swiper-pagination {
      display: flex;
      padding: 0 20px;

      &-bullet {
        background: var(
          --component-slider-color-pagination-inactive-background,
          transparent
        );
        border: 2px solid
          var(
            --component-slider-color-pagination-inactive,
            var(--current-color-primary, $ui-blue)
          );
        height: 20px;
        margin-left: 16px;
        opacity: 1;
        width: 20px;

        &:first-child {
          margin-left: 0;
        }

        &-active {
          background-color: var(
            --component-slider-color-pagination-active-background,
            var(--skin-color-accent, $ui-green)
          );
          border-color: var(
            --component-slider-color-pagination-active,
            var(--skin-color-accent, $ui-green)
          );
        }
      }

      &-fraction {
        color: var(
          --component-slider-color-pagination-inactive,
          var(--current-color-primary, $ui-blue)
        );
        width: auto;
      }

      &-current {
        color: var(
          --component-slider-color-pagination-active,
          var(--skin-color-accent, $ui-green)
        );
        font-weight: $font-weight-bold;
        margin-right: 4px;
      }

      &-total {
        margin-left: 4px;
      }
    }

    .swiper-button-prev,
    .swiper-button-next {
      display: none;
      height: auto;
      margin: 0;

      --component-icon-color: var(--component-slider-color-arrows);

      @include breakpoint($medium) {
        display: flex;
      }

      &.active {
        display: flex;
      }

      &::after {
        display: none;
      }

      ui-icon {
        height: 24px;
        width: 24px;
      }
    }

    &--onSlider {
      @include breakpoint($medium) {
        .swiper-pagination {
          display: none;
        }

        .swiper-button-prev,
        .swiper-button-next {
          display: flex;
          align-items: flex-start;
          position: absolute;
          top: 0;
          width: 200px;
          height: 100%;
          padding-top: 25px;

          &.swiper-button-disabled {
            display: none;
          }
        }

        .swiper-button-prev {
          left: 0;
          justify-content: flex-start;
          background: linear-gradient(
            90deg,
            var(--ui-color-white, $ui-white) 0%,
            rgb(0 0 0 / 0%) 100%
          );
        }

        .swiper-button-next {
          right: 0;
          justify-content: flex-end;
          background: linear-gradient(
            270deg,
            var(--ui-color-white, $ui-white) 0%,
            rgb(0 0 0 / 0%) 100%
          );
        }
      }
    }
  }

  &--full-width {
    width: 100vw;
    margin-left: calc((100% - 100vw) / 2);
  }

  .swiper-slide.swiper-slide-active {
    z-index: 1;
  }

  .hidden {
    display: none;
  }
}

@media print {
  /*
  * The following uses !important, but only for print-styles and therefore should be fine
  */
  /* stylelint-disable declaration-no-important */
  .swiper-wrapper {
    flex-wrap: wrap;
    transform: unset !important; // inline styles generated by js have to be overwritten
    height: unset;
    gap: 35px;

    > * {
      margin-right: 0 !important; // inline styles generated by js have to be overwritten
    }

    > .swiper-slide-duplicate {
      display: none;
    }

    // TODO refactor: remove cms logic from core component
    > ui-cms-superteaser {
      display: none;
    }
  }

  .ui-slider__controls {
    display: none;
  }
}
